import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzI18nService, en_US } from 'ng-zorro-antd/i18n';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { PreferencesFormData } from '../../../interfaces/referralSections.interface';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { performValidation } from '../../../shared/utils/validation.util';
import {
  RADIO_YES_NO_OPTIONS,
  DAYS_OF_WEEK,
  STATIC_DATA,
  SHORT_TO_FULL_DAY
} from '../../../shared/constants/static-data.constants';
import { NzAriaLabelDirective } from '../../../shared/directives/nz-aria-label.directive';
import { UserService } from '../../../services/user.service';
import { MultiselectComponent } from '@ppl/ui';
import { DropdownSelectComponent } from '@ppl/ui';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoFocusFirstInputDirective } from '../../../shared/directives/auto-focus-first-input.directive';

@Component({
  selector: 'ppl-comm-preference',
  standalone: true,
  imports: [
    AutoFocusFirstInputDirective,
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzGridModule,
    NzCardModule,
    NzRadioModule,
    NzSelectModule,
    NzCheckboxModule,
    NzInputModule,
    NzTimePickerModule,
    NzToolTipModule,
    CommonModule,
    DatePickerModule,
    NzAriaLabelDirective,
    MultiselectComponent,
    DropdownSelectComponent
  ],
  templateUrl: './comm-preference.component.html',
  styleUrl: './comm-preference.component.css',
})
export class CommPreferenceComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  preferncesForm!: FormGroup;
  private navigationSubscription: Subscription | undefined;
  @Input() mode = 'edit';
  filledInfo: PreferencesFormData = {};
  participantRegisterMode: any[] = [];
  override daysOfWeek: string[] = DAYS_OF_WEEK;
  shortToFullDayMap: any = SHORT_TO_FULL_DAY;
  contactType: any[] = [];
  languages: any[] = [];
  accommodations: any[] = [];
  formHasBeenFilled = false;
  @Input() source?: string = '';
  radioOptions = RADIO_YES_NO_OPTIONS;
  flow: string | null = '';
  relationshipOptions: any;
  taxExemptOptions: any;
  formReadonly = false;
  formLanguages = [
    {
      lkpValueCode: 'AR',
      lkpValueName: 'Arabic',
    },
    {
      lkpValueCode: 'BN',
      lkpValueName: 'Bangla',
    },
    {
      lkpValueCode: 'CMN',
      lkpValueName: 'Mandarin',
    },
    {
      lkpValueCode: 'EN',
      lkpValueName: 'English',
    },
    {
      lkpValueCode: 'FR',
      lkpValueName: 'French',
    },
    {
      lkpValueCode: 'HT',
      lkpValueName: 'Haitian Creole',
    },
    {
      lkpValueCode: 'IT',
      lkpValueName: 'Italian',
    },
    {
      lkpValueCode: 'JI',
      lkpValueName: 'Yiddish',
    },
    {
      lkpValueCode: 'KO',
      lkpValueName: 'Korean',
    },
    {
      lkpValueCode: 'PL',
      lkpValueName: 'Polish',
    },
    {
      lkpValueCode: 'RU',
      lkpValueName: 'Russian',
    },
    {
      lkpValueCode: 'SP',
      lkpValueName: 'Spanish',
    },
    {
      lkpValueCode: 'UR',
      lkpValueName: 'Urdu',
    },
    {
      lkpValueCode: 'YUE',
      lkpValueName: 'Cantonese',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private i18n: NzI18nService,
    private referralDataService: ReferralDataService,
    private sectionService: SectionsService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.preferncesForm = this.fb.group({
      contactType: [''],
      contactFirstName: [''],
      contactLastName: [''],
      contactEmail: [''],
      contactPhone: [''],
      spokenLanguages: [[]],
      formLanguage: [null],
      primaryLanguage: [null],
      daysToContact: this.fb.array(
        this.daysOfWeek.map(() => this.fb.control(false))
      ),
      startContactTime: [null],
      endContactTime: [null],
      otherDetails: [''],
      specialAccomdation: [''],
      specialAccomdationOther: [''],
      registerPref: [''],
      emergencyContactFirstName: [''],
      emergencyContactLastName: [''],
      emergencyContactPhone: [''],
      taxExempt: [''],
      nprftDocumentationReceived: [''],
      availabilityDays: this.fb.array(
        this.daysOfWeek.map(() => this.fb.control(false))
      ),
      dayEmergencyAvailablityStart: [null, this.dayShiftValidaor.bind(this)],
      dayEmergencyAvailablityEnd: [null, this.dayShiftValidaor.bind(this)],
      nightEmergencyAvailablityStart: [null, this.nightShiftValidaor.bind(this)],
      nightEmergencyAvailablityEnd: [null, this.nightShiftValidaor.bind(this)],
      distanceWillingToTravel: [null],
      availabilityTimingStart: [null],
      availabilityTimingEnd: [null],
      isAvailableForEmergencies: [null],
      bestTimeToContact: ['']
    });
    this.flow = this.sectionService.getFlow()!;
    this.formReadonly = this.referralDataService.getAssociationsEditable();

    if (this.formReadonly) {
      this.preferncesForm.disable();
    } else {
      this.preferncesForm.enable();
    }

    const associationFlows = this.sectionService.getAssociationFlows();
    const program = this.userService.getSelectedProgram();
    const flow = this.sectionService.getFlow();

    let steps: any;
    if (flow === 'providerEnrollment') {
      steps = this.sectionService.getProviderSectionData(
        program?.program_code,
        STATIC_DATA.COMMUNICATION_PREFERENCES
      );
      this.secData = steps;
    } else {
      const providerType = this.referralDataService.getReferralFormData()?.providerType;
      steps = this.sectionService.getSectionData(
        program?.program_code,
        this.source,
        this.referralDataService.getProviderType(this.flow, providerType)
      );
      this.secData = steps[STATIC_DATA.COMMUNICATION_PREFERENCES];
    }

    this.navigationSubscription = this.preferncesForm.valueChanges.subscribe(
      () => {
        const hasValue = this.hasAnyValueInForm(this.preferncesForm);
        this.formHasBeenFilled = hasValue;

        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isCommFormUpdated',
            this.formHasBeenFilled
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isCommFormUpdated',
            this.formHasBeenFilled
          );
        }
        // this.referralDataService.setReferralFormData(
        //   'isCommFormUpdated',
        //   this.formHasBeenFilled
        // );
        const availableDays = this.getDaysSelected(
          this.preferncesForm.value.availabilityDays
        );
        const selectedDays = this.getDaysSelected(
          this.preferncesForm.value.daysToContact
        );
        this.preferncesForm.value.daysToContact = selectedDays;
        this.preferncesForm.value.availabilityDays = availableDays;
        const bestTimeToContact = this.getBestTimeToContact();
        this.preferncesForm.value.bestTimeToContact = bestTimeToContact;
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'commPreferencesData',
            this.preferncesForm.value
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'commPreferencesData',
            this.preferncesForm.value
          );
        }

        this.referralDataService.setChanged(
          !hasValue ? false : this.preferncesForm.dirty || !this.preferncesForm.valid
        );
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isCommFormDirty',
            !hasValue ? false : this.preferncesForm.dirty || !this.preferncesForm.valid
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isCommFormDirty',
            !hasValue ? false : this.preferncesForm.dirty || !this.preferncesForm.valid
          );
        }
      }
    );

    if (associationFlows.includes(this.flow ?? '')) {
      const filledData =
        this.referralDataService.getAssociationDetails('communicationData')!;
      if (filledData) {
        this.preferncesForm.patchValue(filledData);
      }
    }
    if (((flow == 'referral' && this.userService.getLeadEntry() == 'referral') || flow === 'participantEnrollment' || flow === 'providerEnrollment') && !this.referralDataService.getReferralFormData().commPreferencesData) {
      const filledData =
        this.referralDataService.getReferralDetails('communicationData', flow)!;
      if (filledData) {
        if (flow === 'providerEnrollment') {
          const emergencyAvailabilityDay = super.getStartAndEndTimes(
            filledData?.emergencyAvailabilityDay
          );
          const emergencyAvailabilityNight = super.getStartAndEndTimes(
            filledData?.emergencyAvailabilityNight
          );
          const finalData = {
            ...filledData,
            dayEmergencyAvailablityStart: emergencyAvailabilityDay?.startTime,
            dayEmergencyAvailablityEnd: emergencyAvailabilityDay?.endTime,
            nightEmergencyAvailablityStart:
              emergencyAvailabilityNight?.startTime,
            nightEmergencyAvailablityEnd: emergencyAvailabilityNight?.endTime,
          };
          this.preferncesForm.patchValue(finalData);
        } else {
          this.preferncesForm.patchValue(filledData);
        }
      }
    }

    if (!associationFlows.includes(this.flow ?? '')) {
      if (this.referralDataService.getReferralFormData().commPreferencesData) {
        this.filledInfo =
          this.referralDataService.getReferralFormData().commPreferencesData;
        const selectedDays = this.filledInfo.daysToContact;
        const days = this.daysOfWeek.map((day: any) =>
          selectedDays?.includes(day)
        );
        const availabilityDays = this.daysOfWeek.map((day: any) =>
          this.filledInfo.availabilityDays?.includes(day)
        );
        const updatedValues = {
          ...this.filledInfo,
          daysToContact: days,
          availabilityDays,
        };
        this.preferncesForm.patchValue(updatedValues);
      }
    }

    const contactData =
      this.referralDataService.getReferralFormData()?.contactDetailsData;
    const participantRegisterMode = this.getLookup('Participant_Register_Mode');
    this.participantRegisterMode = this.filterPrefLookupValues(
      contactData,
      participantRegisterMode
    );

    this.languages = this.getLookup('Language');
    this.contactType = this.getLookup('Contact_Type');
    this.accommodations = this.getLookup('Special_Accomdation');
    this.taxExemptOptions = this.getLookup('Tax Exemption');

    this.referralDataService.nextClicked.subscribe((val) => {
      if (val === STATIC_DATA.COMMUNICATION_PREFERENCES) {
        this.validationErrors = performValidation(
          this.preferncesForm.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        this.referralDataService.setError(this.validationErrors);
      }
    });

    if (associationFlows.includes(this.flow ?? '')) {
      this.referralDataService.associationSaveClicked.subscribe(() => {
        this.validationErrors = performValidation(
          this.preferncesForm.value,
          this.secData,
          'Next', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType()
        );
        this.referralDataService.setError(this.validationErrors);
        this.referralDataService.setAssociationFormData(
          'isCommFormValid',
          Object.keys(this.validationErrors).length == 0
        );
      });
    }
  }

  getBestTimeToContact() {
    const selectedDaysToContact = this.preferncesForm?.value?.daysToContact;
    const startTime = this.preferncesForm?.value?.startContactTime;
    const endTime = this.preferncesForm?.value?.endContactTime;

    return this.formatBestTimeToContact(selectedDaysToContact, startTime, endTime);
  }

  // hasAnyValue(form: FormGroup): boolean {
  //   return Object.values(form.controls).some(control => control.value !== '');
  // }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  filterPrefLookupValues(data: any, lookupValues: any) {
    // if email and phone both are present
    if (data && data.email && (data.mobile || data.altPhone)) {
      return lookupValues;
    }

    // if only email is present
    if (data && data.email && (!data.mobile && !data.altPhone)) {
      return lookupValues.filter((item: any) => item.lkpValueCode !== 'MOB' && item.lkpValueCode !== 'ALL');
    }

    // if only phone is present
    if (data && (data.mobile || data.telephone) && !data.email) {
      return lookupValues.filter((item: any) => item.lkpValueCode !== 'EML' && item.lkpValueCode !== 'ALL');
    }
    // if none is present, bydefault we are returning all values, need to check on this.
    return lookupValues;
  }

  // Helper to parse string or Date to Date object
  private parseToDate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) return val;
    if (typeof val === 'string') {
      // Handles "9:00 AM" or "21:00"
      const d = new Date();
      let [timePart, modifier] = val.split(' ');
      let [hours, minutes] = timePart.split(':').map(Number);
      if (modifier && modifier.toLowerCase() === 'pm' && hours < 12) hours += 12;
      if (modifier && modifier.toLowerCase() === 'am' && hours === 12) hours = 0;
      d.setHours(hours, minutes || 0, 0, 0);
      return d;
    }
    return null;
  }

  dayShiftValidaor(control: AbstractControl): ValidationErrors | null {
    const dayShiftStartTime = this.parseToDate(this.preferncesForm?.get('dayEmergencyAvailablityStart')?.value);
    const dayShiftEndTime = this.parseToDate(this.preferncesForm?.get('dayEmergencyAvailablityEnd')?.value);
    if (!dayShiftStartTime && dayShiftEndTime) {
      return { dayStartTimeRequired: true };
    }
    if (dayShiftStartTime && !dayShiftEndTime) {
      return { dayEndTimeRequired: true };
    }
    if (dayShiftStartTime && dayShiftEndTime) {
      if (dayShiftStartTime >= dayShiftEndTime) {
        return { dayShiftTimeInvalid: true };
      }
      const startTimehours = dayShiftStartTime.getHours();
      const endTimehours = dayShiftEndTime.getHours();
      if ((endTimehours == 22 && dayShiftEndTime.getMinutes() > 0) || startTimehours < 6 || startTimehours > 22 || endTimehours < 6 || endTimehours > 22) {
        return { dayShiftInvalid: true };
      }
    }
    this.preferncesForm?.get('dayEmergencyAvailablityStart')?.setErrors(null);
    this.preferncesForm?.get('dayEmergencyAvailablityEnd')?.setErrors(null);
    return null; // No validation errors
  }


  nightShiftValidaor(control: AbstractControl): ValidationErrors | null {
    const nightShiftStartTime = this.parseToDate(this.preferncesForm?.get('nightEmergencyAvailablityStart')?.value);
    const nightShiftEndTime = this.parseToDate(this.preferncesForm?.get('nightEmergencyAvailablityEnd')?.value);
    if (!nightShiftStartTime && nightShiftEndTime) {
      return { nightStartTimeRequired: true };
    }
    if (nightShiftStartTime && !nightShiftEndTime) {
      return { nightEndTimeRequired: true };
    }
    if (nightShiftStartTime && nightShiftEndTime) {
      const startTimehours = nightShiftStartTime.getHours();
      const endTimehours = nightShiftEndTime.getHours();
      if (!((startTimehours >= 22 || startTimehours < 6 || (startTimehours == 22 && nightShiftStartTime.getMinutes() == 0))
        && (endTimehours >= 22 || endTimehours < 6 || (endTimehours == 6 && nightShiftEndTime.getMinutes() == 0)))) {
        return { nightShiftInvalid: true };
      }
      // Adjust for night shift crossing midnight
      const updatedNightShiftStartTime = new Date(nightShiftStartTime);
      const updatedNightShiftEndTime = new Date(nightShiftEndTime);
      if (endTimehours <= 6) {
        updatedNightShiftEndTime.setDate(updatedNightShiftEndTime.getDate() + 1);
      }

      if (startTimehours <= 6) {
        updatedNightShiftStartTime.setDate(updatedNightShiftStartTime.getDate() + 1);
      }
      if (updatedNightShiftStartTime >= updatedNightShiftEndTime) {
        return { nightShiftTimeInvalid: true };
      }
    }

    this.preferncesForm?.get('nightEmergencyAvailablityStart')?.setErrors(null);
    this.preferncesForm?.get('nightEmergencyAvailablityEnd')?.setErrors(null);
    return null; // No validation errors
  }
}
